import React, { useState } from "react";

function SkillDetails(props) {
  const [isOpen, setIsOpen] = useState(false);

  function toggleClick() {
    setIsOpen((prevValue) => !prevValue);
  }

  return (
    <div className="skills-divs" onClick={toggleClick}>
      <h2 className="h2-standard">{props.heading}</h2>
      {isOpen && (
        <div className="resume-bullet-points-div">
          {props.list.map((item, index) => (
            <p className="resume-bullet-points" key={index}>
              • {item}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}

export default SkillDetails;
